import React from "react";
import { CheckCircle2, Circle, Dot } from "lucide-react";

// Which services are in the package and how far through each one is. Horizontal
// on a phone or tablet, a column on desktop — the same list either way, so moving
// between services never loses an answer.
export default function ServiceNav({ sections, index, onGo }) {
  return (
    <nav aria-label="Your services" data-testid="pricing-service-nav">
      <p className="hidden lg:block text-[11px] font-bold uppercase tracking-widest text-slate-400 mb-3">Your services</p>
      <ul className="flex lg:block gap-2 overflow-x-auto pb-2 lg:pb-0 -mx-1 px-1 lg:mx-0 lg:px-0 lg:space-y-1">
        {sections.map((sec, i) => {
          const active = i === index;
          const done = sec.complete;
          return (
            <li key={sec.service.service_id} className="shrink-0 lg:shrink">
              <button
                type="button"
                onClick={() => onGo(i)}
                aria-current={active ? "true" : undefined}
                data-testid={`pricing-nav-${sec.service.service_id}`}
                className={`w-full text-left rounded-xl px-3 py-2.5 text-sm font-semibold transition-colors flex items-center gap-2 whitespace-nowrap lg:whitespace-normal ${
                  active ? "bg-navy text-white" : "text-slate-600 hover:bg-slate-100"
                }`}
              >
                {done ? (
                  <CheckCircle2 size={14} className={active ? "text-white shrink-0" : "text-teal shrink-0"} />
                ) : active ? (
                  <Dot size={14} className="shrink-0" />
                ) : (
                  <Circle size={14} className="text-slate-300 shrink-0" />
                )}
                <span className="min-w-0 lg:truncate">{sec.service.name}</span>
                {sec.required > 0 && (
                  <span className={`ml-auto text-[10px] font-bold tabular-nums ${active ? "text-white/70" : "text-slate-400"}`}>
                    {sec.answered}/{sec.required}
                  </span>
                )}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
